export default __webpack_public_path__ + "static/media/bg-fifa-2.7c1c4906.png";